import { ReactNode } from "react";

/**
 * Enum defining known feature flag keys used in the application.
 */
export enum FeatureFlagKey {
  AccountNumberField = "AccountNumberField",
  BillingStatements = "BillingStatements",
  GroupReporting = "GroupReporting",
  GroupInformation = "GroupInformation",
  WellsFargoSSO = "WellsFargoSSO",
}

/**
 * Interface for legacy version-specific flags, supporting dynamic version keys.
 * @example { v1: true, v2: false, v3: true }
 */
export interface LegacyVersionFlags {
  [key: string]: boolean | undefined;
  v1?: boolean;
  v2?: boolean;
}

/**
 * Interface for legacy versioned feature flags with nested version flags and visibility.
 * @example { version: { v1: true, v2: false }, visible: true }
 */
export interface LegacyVersionedFeatureFlag {
  version?: LegacyVersionFlags;
  visible: boolean;
}

/**
 * Union type representing possible feature flag values: either a legacy versioned object or a simple boolean.
 */
export type FeatureFlagValue = LegacyVersionedFeatureFlag | boolean;

/**
 * Type mapping specific feature flag keys to their possible values.
 * Each key (FeatureA, FeatureB) can be a versioned object or boolean.
 */
export type SpecificFeatureFlags = { [K in FeatureFlagKey]: FeatureFlagValue };

/**
 * Interface for all feature flags, extending specific flags with dynamic keys.
 * Flags can be versioned objects, booleans, or undefined.
 * @example { FeatureA: { version: { v1: true }, visible: false }, FeatureB: true, extraFlag: false }
 */
// export interface FeatureFlags extends Partial<SpecificFeatureFlags> {
//   [key: string]: FeatureFlagValue | undefined;
// }
export interface FeatureFlags {
  [key: string]: boolean;
}

/**
 * Props interface for the FeatureFlagProvider component.
 */
export interface FeatureFlagProviderProps {
  children: ReactNode;
}
